import { useState, Fragment, useEffect } from 'react';
import {
  Card,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
  Grid,
  Button,
  TableFooter,
  Box
} from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import './ResourcePool.css';
import { withStyles } from '@mui/styles';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import Indicator from './common/Indicator';

interface TracksProps {
  data: any;
  trackDetails: any;
}

const Tracks = (props: TracksProps) => {
  const [trackExpand, setTrackExpand] = useState<any>();
  const [roleExpand, setRoleExpand] = useState<any>();
  const [allocationExpand, setAllocationExpand] = useState<any>();
  const [tracks, setTracks] = useState<any>([]);


  useEffect(() => {
    setTracks(props?.data);
  }, [props?.data])
  

  const handleAllocationExpand = (id) => {
    setAllocationExpand(
      {
        id: id,
        expand: allocationExpand?.id === id ? !allocationExpand.expand : true
      }
    );
  }

  const handleTrackExpand = (trackId) => {
    setTrackExpand(
      {
        trackId: trackId,
        expand: trackExpand?.trackId === trackId ? !trackExpand.expand : true
      }
    );
  }

  const handleRoleExpand = (roleId) => {
    setRoleExpand(
      {
        roleId: roleId,
        expand: roleExpand?.roleId === roleId ? !roleExpand.expand : true
      }
    );
  }

  // custom table row with different color
  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3rem'
    }
  })(TableRow);

  return (
    <div className='resource-pool-dashboard-tracks'>
      <Box style={{display: 'flex', flexDirection: 'row'}}>
        <Indicator color='red' description='Inactive Resource'/>
        <Indicator color='orange' description='Inactive Project'/>
      </Box>
      <Card>
        <TableContainer className="tableContainer">
          <Table style={{ borderCollapse: 'separate', position: 'relative' }} size="small">
            <TableHead>
              <CustomTableRow style={{position: 'sticky', top: 0, zIndex: 1}}>
                <TableHeaderCell className='tree-button' content="" smallFont/>
                <TableHeaderCell width="150px" content="Tracks" smallFont/>
                <TableHeaderCell width="100px" content="Client Name" smallFont/>
                <TableHeaderCell width="100px" content="Project Name" smallFont/>
                <TableHeaderCell width="100px" content="Project Role" smallFont/>
                <TableHeaderCell width="100px" content="Allocation Type" smallFont/>
                <TableHeaderCell className='head-center' content="Resource Allocation" smallFont/>
                <TableHeaderCell className='head-center' content="Billable" smallFont/>
                <TableHeaderCell className='head-center' content="Billable %" smallFont/>
                <TableHeaderCell className='head-center' content="Non-Billable" smallFont />
                <TableHeaderCell className='head-center' content="Non-Billable %" smallFont />
              </CustomTableRow>
            </TableHead>
            <TableBody>
              { tracks &&
                tracks?.length > 0 &&
                tracks.map((track, i) => {
                  return (
                    <Fragment key={track?.id}>
                      <TableRow
                        hover
                        key={track?.id}
                        className='track-row'
                      >
                        <TableColumnCell className='tree-button'>
                            { (track?.roles?.flatMap(res => res?.resources).flatMap(all => all?.allocations).reduce((total, obj) => total + parseFloat(obj?.allocation), 0).toFixed(2) !== "0.00" ||
                              track?.roles?.flatMap(role => role?.resources).reduce((total, obj) => total + parseFloat(obj?.billableCount), 0).toFixed(2) !== "0.00" ||
                              track?.roles?.flatMap(role => role?.resources).reduce((total, obj) => total + parseFloat(obj?.nonBillableCount), 0).toFixed(2) !== "0.00") &&
                              <Button
                                sx={{
                                  color: '#223354',
                                  backgroundColor: 'white',
                                  mt: { xs: 2, md: 0 },
                                  fontSize: '11px',
                                  fontWeight: 'normal',
                                  width: '14px',
                                  height: '14px',
                                  padding: 0,
                                  minWidth: 'unset',
                                  borderRadius: '2px',
                                  cursor: 'pointer'
                                }}
                                onClick={e => handleTrackExpand(track?.id)}
                                variant="contained"
                                startIcon={trackExpand?.trackId === track?.id && trackExpand?.expand ? <HorizontalRuleIcon fontSize="small" style={{fontSize: '14px'}}/> : 
                                <AddTwoToneIcon fontSize="small" style={{fontSize: '14px'}}/>}
                              />
                            }
                        </TableColumnCell>
                        <TableColumnCell>
                          <Grid display='flex' alignItems='center' justifyContent='flex-start' gap={1}>
                            <Typography
                              paddingBottom="0.25rem"
                              paddingTop="0.5rem"
                              variant="body2"
                              style={{ fontSize: '11px' }}
                              gutterBottom
                              noWrap
                            >
                              {track?.trackCode === "Dev" ? "Development" : track?.track}
                            </Typography>
                          </Grid>
                        </TableColumnCell>
                        <TableColumnCell></TableColumnCell>
                        <TableColumnCell></TableColumnCell>
                        <TableColumnCell></TableColumnCell>
                        <TableColumnCell></TableColumnCell>
                        <TableColumnCell className='cell-text-wrap-pretty'>
                          <Typography
                            paddingBottom="0.25rem"
                            paddingTop="0.5rem"
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {track?.roles?.flatMap(role => role?.resources).flatMap(all => all?.allocations).reduce((total, obj) => total + parseFloat(obj?.allocation), 0).toFixed(2)}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell className='cell-text-wrap-pretty'>
                          <Typography
                            paddingBottom="0.25rem"
                            paddingTop="0.5rem"
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {(track?.roles?.flatMap(role => role?.resources).reduce((total, obj) => total + parseFloat(obj?.billableCount), 0) / 
                              track?.roles.flatMap(role => role?.resources).length).toFixed(2)}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell className='cell-text-wrap-pretty'>
                          <Typography
                            paddingBottom="0.25rem"
                            paddingTop="0.5rem"
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {track?.roles?.flatMap(role => role?.resources).reduce((total, obj) => total + parseFloat(obj?.billablePercentage ? obj?.billablePercentage : 0), 0) !== 0 ? 
                              (track?.roles?.flatMap(role => role?.resources).reduce((total, obj) => total + parseFloat(obj?.billablePercentage ? obj?.billablePercentage : 0), 0) / 
                              track?.roles.flatMap(role => role?.resources).length).toFixed(2) + '%'
                              : '0.00%'}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell className='cell-text-wrap-pretty'>
                          <Typography
                            paddingBottom="0.25rem"
                            paddingTop="0.5rem"
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {(track?.roles?.flatMap(role => role?.resources).reduce((total, obj) => total + parseFloat(obj?.nonBillableCount), 0) / 
                            track?.roles.flatMap(role => role?.resources).length).toFixed(2)}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell className='cell-text-wrap-pretty'>
                          <Typography
                            paddingBottom="0.25rem"
                            paddingTop="0.5rem"
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {track?.roles?.flatMap(role => role?.resources).reduce((total, obj) => total + parseFloat(obj?.nonBillablePercentage ? obj?.nonBillablePercentage : 0), 0) !== 0 ? 
                              (track?.roles?.flatMap(role => role?.resources).reduce((total, obj) => total + parseFloat(obj?.nonBillablePercentage ? obj?.nonBillablePercentage : 0), 0) / 
                              track?.roles.flatMap(role => role?.resources).length).toFixed(2) + '%'
                              : '0.00%'}
                          </Typography>
                        </TableColumnCell>
                      </TableRow>
                      {
                        trackExpand?.trackId === track?.id && trackExpand?.expand && track?.roles?.length > 0 && track?.roles?.map((role, index) => {
                          if(role?.resources.length > 0){
                            return (
                              <Fragment key={role?.id}>
                              <TableRow
                                hover
                                key={index}
                                className='role-row'
                              >
                                <TableColumnCell className='tree-button'></TableColumnCell>
                                <TableColumnCell>
                                  <div style={{display: 'flex', alignItems: 'center'}}>
                                    <div className='border-0' style={{width: '40px'}}>
                                      { role?.resources.length > 0 && 
                                        <Button
                                          sx={{
                                            color: '#223354',
                                            backgroundColor: 'white',
                                            mt: { xs: 2, md: 0 },
                                            fontSize: '11px',
                                            fontWeight: 'normal',
                                            width: '14px',
                                            height: '14px',
                                            padding: 0,
                                            minWidth: 'unset',
                                            borderRadius: '2px',
                                            cursor: 'pointer'
                                          }}
                                          onClick={e => handleRoleExpand(role?.id)}
                                          variant="contained"
                                          startIcon={roleExpand?.roleId === role?.id && roleExpand?.expand ? <HorizontalRuleIcon fontSize="small" style={{fontSize: '14px'}}/> : 
                                          <AddTwoToneIcon fontSize="small" style={{fontSize: '14px'}}/>}
                                        />
                                      }
                                    </div>
                                    <div className='border-0'>
                                      <Typography
                                        marginBottom={0}
                                        paddingBottom="0.25rem"
                                        paddingTop="0.5rem"
                                        variant="body2"
                                        style={{ fontSize: '11px' }}
                                        color="text.primary"
                                        gutterBottom
                                        noWrap
                                      >
                                        {role?.name}
                                      </Typography>
                                    </div>
                                  </div>
                                </TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell className='cell-text-wrap-pretty'>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    color="text.primary"
                                    gutterBottom
                                    noWrap
                                  >
                                    {role?.resources?.flatMap(all => all?.allocations).reduce((total, obj) => total + parseFloat(obj?.allocation), 0).toFixed(2)}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell className='cell-text-wrap-pretty'>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    color="text.primary"
                                    gutterBottom
                                    noWrap
                                  >
                                    {(role?.resources?.reduce((total, obj) => total + parseFloat(obj?.billableCount), 0) / role?.resources?.length).toFixed(2)}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell className='cell-text-wrap-pretty'>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    color="text.primary"
                                    gutterBottom
                                    noWrap
                                  >
                                    {role?.resources?.reduce((total, obj) => total + parseFloat(obj?.billablePercentage ? obj?.billablePercentage : 0), 0) !== 0 ? 
                                    (role?.resources?.reduce((total, obj) => total + parseFloat(obj?.billablePercentage ? obj?.billablePercentage : 0), 0) /
                                    role?.resources?.length).toFixed(2) + '%'
                                    : '0.00%'}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell className='cell-text-wrap-pretty'>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    color="text.primary"
                                    gutterBottom
                                    noWrap
                                  >
                                    {(role?.resources?.reduce((total, obj) => total + parseFloat(obj?.nonBillableCount), 0) / role?.resources?.length).toFixed(2)}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell className='cell-text-wrap-pretty'>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    color="text.primary"
                                    gutterBottom
                                    noWrap
                                  >
                                    {role?.resources?.reduce((total, obj) => total + parseFloat(obj?.nonBillablePercentage ? obj?.nonBillablePercentage : 0), 0) !== 0 ? 
                                    (role?.resources?.reduce((total, obj) => total + parseFloat(obj?.nonBillablePercentage ? obj?.nonBillablePercentage : 0), 0) /
                                    role?.resources?.length).toFixed(2) + '%'
                                    : '0.00%'}
                                  </Typography>
                                </TableColumnCell>
                              </TableRow>
                                { roleExpand?.roleId === role?.id && roleExpand?.expand && role?.resources?.length > 0 && 
                                  role?.resources.map((resource, index) => {
                                    return (
                                      <Fragment>
                                        <TableRow
                                          hover
                                          key={index}
                                          className='resource-row'
                                        >
                                          <TableColumnCell className='tree-button'></TableColumnCell>
                                          <TableColumnCell>
                                            <div style={{display: 'flex', alignItems: 'center', marginLeft: '20px'}}>
                                              <div className='border-0' style={{width: '20px'}}>
                                                { resource?.allocations?.length > 1 && 
                                                  <Button
                                                    sx={{
                                                      color: '#223354',
                                                      backgroundColor: 'white',
                                                      mt: { xs: 2, md: 0 },
                                                      fontSize: '11px',
                                                      fontWeight: 'normal',
                                                      width: '14px',
                                                      height: '14px',
                                                      padding: 0,
                                                      minWidth: 'unset',
                                                      borderRadius: '2px',
                                                      cursor: 'pointer'
                                                    }}
                                                    onClick={e => handleAllocationExpand(resource?.employeeId)}
                                                    variant="contained"
                                                    startIcon={allocationExpand?.id === resource?.employeeId && allocationExpand?.expand ? <HorizontalRuleIcon fontSize="small" style={{fontSize: '14px'}}/> : 
                                                    <AddTwoToneIcon fontSize="small" style={{fontSize: '14px'}}/>}
                                                  />
                                                }
                                              </div>
                                              <div className='border-0'>
                                                <div style={{display: 'flex', alignItems: 'center', paddingLeft: '20px'}}>
                                                  {(!resource?.allocations[0]?.isActiveEmployee && resource?.allocations[0]?.isActiveEmployee !== undefined) && (
                                                    <div style={{width: '25px'}} className='border-0'>
                                                      <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'left'}}>
                                                        <Indicator size={5} color='red'/>
                                                      </Box>
                                                    </div>
                                                  )}
                                                  <div className='border-0'>
                                                    <Grid>
                                                      <Typography
                                                        paddingBottom="0.25rem"
                                                        paddingTop="0.5rem"
                                                        variant="body2"
                                                        style={{ fontSize: '11px' }}
                                                        color="text.primary"
                                                        gutterBottom
                                                        noWrap
                                                      >
                                                        {resource?.name}
                                                      </Typography>
                                                      {resource?.allocations.length === 0 && 
                                                      <Typography noWrap style={{fontSize: '9px', color: 'blue'}}>(There is No allocation found for this resource for the given date range)</Typography>}
                                                    </Grid>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </TableColumnCell>
                                          <TableColumnCell>
                                            <Typography
                                              paddingBottom="0.25rem"
                                              paddingTop="0.5rem"
                                              variant="body2"
                                              style={{ fontSize: '11px' }}
                                              color="text.primary"
                                              gutterBottom
                                              noWrap
                                            >
                                              {resource?.allocations?.length === 1 ? resource?.allocations[0]?.client : '-'}
                                            </Typography>
                                          </TableColumnCell>
                                          <TableColumnCell>
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                              {(!resource?.allocations[0]?.isActiveProject && resource?.allocations[0]?.isActiveProject !== undefined) && (
                                                <div style={{width: '25px'}} className='border-0'>
                                                  <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'left'}}>
                                                    {!resource?.allocations[0]?.isActiveProject && <Indicator size={5} color='orange'/>}
                                                  </Box>
                                                </div>)
                                              }
                                              <div className='border-0'>
                                                <Typography
                                                  paddingBottom="0.25rem"
                                                  paddingTop="0.5rem"
                                                  variant="body2"
                                                  style={{ fontSize: '11px' }}
                                                  color="text.primary"
                                                  gutterBottom
                                                  noWrap
                                                >
                                                  {resource?.allocations?.length === 1 ? resource?.allocations[0]?.allocatedProject : '-'}
                                                </Typography>
                                              </div>
                                            </div>
                                          </TableColumnCell>
                                          <TableColumnCell>
                                            <Typography
                                              paddingBottom="0.25rem"
                                              paddingTop="0.5rem"
                                              variant="body2"
                                              style={{ fontSize: '11px' }}
                                              color="text.primary"
                                              gutterBottom
                                              noWrap
                                            >
                                              {resource?.allocations?.length === 1 ? resource?.allocations[0]?.projectRole : '-'}
                                            </Typography>
                                          </TableColumnCell>
                                          <TableColumnCell>
                                            <Typography
                                              paddingBottom="0.25rem"
                                              paddingTop="0.5rem"
                                              variant="body2"
                                              style={{ fontSize: '11px' }}
                                              color="text.primary"
                                              gutterBottom
                                              noWrap
                                            >
                                              {resource?.allocations?.length === 1 ? resource?.allocations[0]?.resourceType : '-'}
                                            </Typography>
                                          </TableColumnCell>
                                          <TableColumnCell className='cell-text-wrap-pretty'>
                                            <Typography
                                              paddingBottom="0.25rem"
                                              paddingTop="0.5rem"
                                              variant="body2"
                                              style={{ fontSize: '11px' }}
                                              color="text.primary"
                                              gutterBottom
                                              noWrap
                                            >
                                              {resource?.allocations?.length === 1 ? resource?.allocations[0]?.allocation : 
                                              (resource?.allocations?.reduce((total, obj) => total + parseFloat(obj?.allocation), 0)).toFixed(2)}
                                            </Typography>
                                          </TableColumnCell>
                                          <TableColumnCell className='cell-text-wrap-pretty'>
                                            <Typography
                                              paddingBottom="0.25rem"
                                              paddingTop="0.5rem"
                                              variant="body2"
                                              style={{ fontSize: '11px' }}
                                              color="text.primary"
                                              gutterBottom
                                              noWrap
                                            >
                                              {resource?.allocations?.length === 1 ? resource?.billableCount : 
                                              (resource?.billableCount).toFixed(2)}
                                            </Typography>
                                          </TableColumnCell>
                                          <TableColumnCell className='cell-text-wrap-pretty'>
                                            <Typography
                                              paddingBottom="0.25rem"
                                              paddingTop="0.5rem"
                                              variant="body2"
                                              style={{ fontSize: '11px' }}
                                              color="text.primary"
                                              gutterBottom
                                              noWrap
                                            >
                                              {resource?.allocations?.length === 1 ? (resource?.billablePercentage ? resource?.billablePercentage : 0).toFixed(2) + '%' : 
                                              (resource?.billablePercentage ? resource?.billablePercentage : 0).toFixed(2) + '%'}
                                            </Typography>
                                          </TableColumnCell>
                                          <TableColumnCell className='cell-text-wrap-pretty'>
                                            <Typography
                                              paddingBottom="0.25rem"
                                              paddingTop="0.5rem"
                                              variant="body2"
                                              style={{ fontSize: '11px' }}
                                              color="text.primary"
                                              gutterBottom
                                              noWrap
                                            >
                                              {resource?.allocations?.length === 1 ? resource?.nonBillableCount : 
                                              (resource?.nonBillableCount).toFixed(2)}
                                            </Typography>
                                          </TableColumnCell>
                                          <TableColumnCell className='cell-text-wrap-pretty'>
                                            <Typography
                                              paddingBottom="0.25rem"
                                              paddingTop="0.5rem"
                                              variant="body2"
                                              style={{ fontSize: '11px' }}
                                              color="text.primary"
                                              gutterBottom
                                              noWrap
                                            >
                                              {resource?.allocations?.length === 1 ? (resource?.nonBillablePercentage ? resource?.nonBillablePercentage : 0).toFixed(2) + '%' : 
                                              (resource?.nonBillablePercentage ? resource?.nonBillablePercentage : 0).toFixed(2) + '%'}
                                            </Typography>
                                          </TableColumnCell>
                                        </TableRow>
                                        { allocationExpand?.id === resource?.employeeId && allocationExpand?.expand && resource?.allocations?.length > 1 && 
                                          resource?.allocations?.map((all, index) => {
                                            return (
                                              <TableRow
                                                hover
                                                key={index}
                                                className='row'
                                              >
                                                <TableColumnCell className='tree-button'></TableColumnCell>
                                                <TableColumnCell></TableColumnCell>
                                                <TableColumnCell>
                                                  <Typography
                                                    paddingBottom="0.25rem"
                                                    paddingTop="0.5rem"
                                                    variant="body2"
                                                    style={{ fontSize: '11px' }}
                                                    color="text.primary"
                                                    gutterBottom
                                                    noWrap
                                                  >
                                                    {all?.client}
                                                  </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell>
                                                  <div style={{display: 'flex', alignItems: 'center'}}>
                                                    {!all.isActiveProject && (
                                                      <div style={{width: '25px'}} className='border-0'>
                                                        <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'left'}}>
                                                          {!all.isActiveProject && <Indicator size={5} color='orange'/>}
                                                        </Box>
                                                      </div>)
                                                    }
                                                    <div className='border-0'>
                                                      <Typography
                                                        paddingBottom="0.25rem"
                                                        paddingTop="0.5rem"
                                                        variant="body2"
                                                        style={{ fontSize: '11px' }}
                                                        color="text.primary"
                                                        gutterBottom
                                                        noWrap
                                                      >
                                                        {all?.allocatedProject}
                                                      </Typography>
                                                    </div>
                                                  </div>
                                                </TableColumnCell>
                                                <TableColumnCell>
                                                  <Typography
                                                    paddingBottom="0.25rem"
                                                    paddingTop="0.5rem"
                                                    variant="body2"
                                                    style={{ fontSize: '11px' }}
                                                    color="text.primary"
                                                    gutterBottom
                                                    noWrap
                                                  >
                                                    {all?.projectRole}
                                                  </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell className='cell-text-wrap-pretty'>
                                                  <Typography
                                                    paddingBottom="0.25rem"
                                                    paddingTop="0.5rem"
                                                    variant="body2"
                                                    style={{ fontSize: '11px' }}
                                                    color="text.primary"
                                                    gutterBottom
                                                    noWrap
                                                  >
                                                    {all?.resourceType}
                                                  </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell className='cell-text-wrap-pretty'>
                                                  <Typography
                                                    paddingBottom="0.25rem"
                                                    paddingTop="0.5rem"
                                                    variant="body2"
                                                    style={{ fontSize: '11px' }}
                                                    color="text.primary"
                                                    gutterBottom
                                                    noWrap
                                                  >
                                                    {all?.allocation?.toFixed(2)}
                                                  </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell className='cell-text-wrap-pretty'>
                                                  <Typography
                                                    paddingBottom="0.25rem"
                                                    paddingTop="0.5rem"
                                                    variant="body2"
                                                    style={{ fontSize: '11px' }}
                                                    color="text.primary"
                                                    gutterBottom
                                                    noWrap
                                                  >
                                                    {all?.billableCount?.toFixed(2)}
                                                  </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell className='cell-text-wrap-pretty'>
                                                  <Typography
                                                    paddingBottom="0.25rem"
                                                    paddingTop="0.5rem"
                                                    variant="body2"
                                                    style={{ fontSize: '11px' }}
                                                    color="text.primary"
                                                    gutterBottom
                                                    noWrap
                                                  >
                                                    {(all?.billablePercentage ? all?.billablePercentage : 0).toFixed(2) + '%'}
                                                  </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell className='cell-text-wrap-pretty'>
                                                  <Typography
                                                    paddingBottom="0.25rem"
                                                    paddingTop="0.5rem"
                                                    variant="body2"
                                                    style={{ fontSize: '11px' }}
                                                    color="text.primary"
                                                    gutterBottom
                                                    noWrap
                                                  >
                                                    {all?.nonBillableCount?.toFixed(2)}
                                                  </Typography>
                                                </TableColumnCell>
                                                <TableColumnCell className='cell-text-wrap-pretty'>
                                                  <Typography
                                                    paddingBottom="0.25rem"
                                                    paddingTop="0.5rem"
                                                    variant="body2"
                                                    style={{ fontSize: '11px' }}
                                                    color="text.primary"
                                                    gutterBottom
                                                    noWrap
                                                  >
                                                    {(all?.nonBillablePercentage ? all?.nonBillablePercentage : 0).toFixed(2) + '%'}
                                                  </Typography>
                                                </TableColumnCell>
                                              </TableRow>
                                            );
                                          })
                                        }
                                      </Fragment>
                                    );
                                  })
                                }
                              </Fragment>
                            );
                          }
                        })
                      }
                    </Fragment>
                  );
                })
              }
            </TableBody>
            <TableFooter>
              <CustomTableRow style={{position: 'sticky', top: 0, zIndex: 1}}>
                <TableHeaderCell className='tree-button' content="" smallFont/>
                <TableHeaderCell width="100px" content="Total Utilization" smallFont/>
                <TableHeaderCell width="150px" content="" smallFont/>
                <TableHeaderCell width="150px" content="" smallFont/>
                <TableHeaderCell width="150px" content="" smallFont/>
                <TableHeaderCell width="150px" content="" smallFont/>
                <TableHeaderCell className='head-center' content={tracks?.flatMap(track => track?.roles).flatMap(role => role?.resources).flatMap(all => all.allocations).reduce((total, obj) => total + parseFloat(obj?.allocation), 0).toFixed(2).toString()} smallFont/>
                <TableHeaderCell className='head-center' content={props?.trackDetails?.totalBillableResources?.toString()} smallFont/>
                <TableHeaderCell className='head-center' content={props?.trackDetails?.totalBillablePercentage?.toString()} smallFont/>
                <TableHeaderCell className='head-center' content={props?.trackDetails?.totalNonBillableResources?.toString()} smallFont />
                <TableHeaderCell className='head-center' content={props?.trackDetails?.totalNonBillablePercentage?.toString()} smallFont/>
              </CustomTableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Card>
    </div>
  );
};

export default Tracks;
